// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__JI6L9","label":"Labeled_label__12l2F","divider":"Labeled_divider__3rz7L"};